import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_USER_SERVICE_API_URL;

class UserService {
  // getUserBoard() {
  //   return axios.get(API_URL + 'home', { headers: authHeader() });
  // }

  // getManagerBoard() {
  //   return axios.get(API_URL + 'user_management', { headers: authHeader() });
  // }

  isPurchaseEquity() {
    return axios.get(API_URL + 'purchase_equity', { headers: authHeader() });
  }

  isPurchaseBond() {
    return axios.get(API_URL + 'purchase_bond', { headers: authHeader() });
  }

  isPurchaseMoneyMarket() {
    return axios.get(API_URL + 'purchase_mm', { headers: authHeader() });
  }

  isPurchaseProperty() {
    return axios.get(API_URL + 'purchase_property', { headers: authHeader() });
  }

  isSellEquity() {
    return axios.get(API_URL + 'sell_equity', { headers: authHeader() });
  }

  isSellBond() {
    return axios.get(API_URL + 'sell_bond', { headers: authHeader() });
  }

  isSellMoneyMarket() {
    return axios.get(API_URL + 'sell_mm', { headers: authHeader() });
  }

  isSellProperty() {
    return axios.get(API_URL + 'sell_property', { headers: authHeader() });
  }

  isInternalAssetTransfer() {
    return axios.get(API_URL + 'internal_asset_transfer', { headers: authHeader() });
  }

  isReversal() {
    return axios.get(API_URL + 'reversal', { headers: authHeader() });
  }

  isContributions() {
    return axios.get(API_URL + 'contributions', { headers: authHeader() });
  }

  isWithdrawals() {
    return axios.get(API_URL + 'withdrawals', { headers: authHeader() });
  }

  isCreditAdjustment() {
    return axios.get(API_URL + 'credit_adjustment', { headers: authHeader() });
  }

  isDebitAdjustment() {
    return axios.get(API_URL + 'debit_adjustment', { headers: authHeader() });
  }

  isIncome() {
    return axios.get(API_URL + 'income', { headers: authHeader() });
  }

  isSettlement() {
    return axios.get(API_URL + 'settlement', { headers: authHeader() });
  }

  isBonds() {
    return axios.get(API_URL + 'bonds', { headers: authHeader() });
  }

  isProperties() {
    return axios.get(API_URL + 'properties', { headers: authHeader() });
  }

  isClientDetails() {
    return axios.get(API_URL + 'client_details', { headers: authHeader() });
  }

  isMMInstruments() {
    return axios.get(API_URL + 'mm_instruments', { headers: authHeader() });
  }

  isRates() {
    return axios.get(API_URL + 'rates', { headers: authHeader() });
  }

  isListedEquities() {
    return axios.get(API_URL + 'listed_equities', { headers: authHeader() });
  }

  isListedEquityPrices() {
    return axios.get(API_URL + 'listed_equity_prices', { headers: authHeader() });
  }

  isUnlistedEquities() {
    return axios.get(API_URL + 'unlisted_equities', { headers: authHeader() });
  }

  isUnlistedEquityPrices() {
    return axios.get(API_URL + 'unlisted_equity_prices', { headers: authHeader() });
  }

  isCounterParties() {
    return axios.get(API_URL + 'counter_parties', { headers: authHeader() });
  }

  isDealer() {
    return axios.get(API_URL + 'dealers', { headers: authHeader() });
  }
  
  isDealerLimits() {
    return axios.get(API_URL + 'dealer_limits', { headers: authHeader() });
  }

  isCustodians() {
    return axios.get(API_URL + 'custodians', { headers: authHeader() });
  }

  isChargeMappings() {
    return axios.get(API_URL + 'charge_mappings', { headers: authHeader() });
  }

  isFeesManagement() {
    return axios.get(API_URL + 'fees_management', { headers: authHeader() });
  }

  isTaxes() {
    return axios.get(API_URL + 'taxes', { headers: authHeader() });
  }

  isTransactionCharges() {
    return axios.get(API_URL + 'transaction_charges', { headers: authHeader() });
  }

  isConfirmationSettings() {
    return axios.get(API_URL + 'confirmation_settings', { headers: authHeader() });
  }

  isOffices() {
    return axios.get(API_URL + 'offices', { headers: authHeader() });
  }

  isBanks() {
    return axios.get(API_URL + 'banks', { headers: authHeader() });
  }

  isCountries() {
    return axios.get(API_URL + 'countries', { headers: authHeader() });
  }

  isCities() {
    return axios.get(API_URL + 'cities', { headers: authHeader() });
  }

  isCurrencies() {
    return axios.get(API_URL + 'currencies', { headers: authHeader() });
  }

  isDealerGroups() {
    return axios.get(API_URL + 'dealer_groups', { headers: authHeader() });
  }

  isDeliveryMethods() {
    return axios.get(API_URL + 'delivery_methods', { headers: authHeader() });
  }

  isContributionMethods() {
    return axios.get(API_URL + 'contribution_methods', { headers: authHeader() });
  }

  isFrequencies() {
    return axios.get(API_URL + 'frequencies', { headers: authHeader() });
  }

  isHolidays() {
    return axios.get(API_URL + 'holidays', { headers: authHeader() });
  }

  isOverrideReasons() {
    return axios.get(API_URL + 'override_reasons', { headers: authHeader() });
  }

  isRejectionReasons() {
    return axios.get(API_URL + 'rejection_reasons', { headers: authHeader() });
  }

  isSectors() {
    return axios.get(API_URL + 'sectors', { headers: authHeader() });
  }

  isStatusAccount() {
    return axios.get(API_URL + 'status_account', { headers: authHeader() });
  }

  isStatusCustodians() {
    return axios.get(API_URL + 'status_custodians', { headers: authHeader() });
  }

  isStatusProperty() {
    return axios.get(API_URL + 'status_property', { headers: authHeader() });
  }

  isExchangePairs() {
    return axios.get(API_URL + 'exchange_pairs', { headers: authHeader() });
  }

  isTitles() {
    return axios.get(API_URL + 'titles', { headers: authHeader() });
  }

  isBankAccountTypes() {
    return axios.get(API_URL + 'bank_account_types', { headers: authHeader() });
  }

  isCallAccountTypes() {
    return axios.get(API_URL + 'call_account_types', { headers: authHeader() });
  }

  isClientTypes() {
    return axios.get(API_URL + 'client_types', { headers: authHeader() });
  }

  isBondInvestmentTypes() {
    return axios.get(API_URL + 'bond_investment_types', { headers: authHeader() });
  }

  isIdentityTypes() {
    return axios.get(API_URL + 'identity_types', { headers: authHeader() });
  }

  isPropertyTypes() {
    return axios.get(API_URL + 'property_types', { headers: authHeader() });
  }

  isTransactionCodes() {
    return axios.get(API_URL + 'transaction_codes', { headers: authHeader() });
  }

  isUnitTrust() {
    return axios.get(API_URL + 'unit_trust', { headers: authHeader() });
  }

  isUsers() {
    return axios.get(API_URL + 'users', { headers: authHeader() });
  }

  isRoles() {
    return axios.get(API_URL + 'roles', { headers: authHeader() });
  }

  isGeneralSecurity() {
    return axios.get(API_URL + 'general_security', { headers: authHeader() });
  }

  isPeriodEnd() {
    return axios.get(API_URL + 'period_end', { headers: authHeader() });
  }

  isPeriodDefination() {
    return axios.get(API_URL + 'period_defination', { headers: authHeader() });
  }

  isSystemDefaults() {
    return axios.get(API_URL + 'system_defaults', { headers: authHeader() });
  }

  isReports() {
    return axios.get(API_URL + 'reports', { headers: authHeader() });
  }
}

export default new UserService();